@import "../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  block-size: 100%;
  grid-template-rows: max-content 1fr max-content;
}

section {
  display: contents;
}

.header__field-group {
  grid-template:
    "export-file-name buttons-container" max-content
    "checkboxes checkboxes" max-content
    / 1fr max-content;
}
.export-file-name {
  grid-area: export-file-name;
}

.header__buttons-container {
  grid-area: buttons-container;
}
.header__checkboxes {
  grid-area: checkboxes;
  grid-template-columns: max-content max-content;
}

.main {
  position: relative;
  padding-block: 12px;
}
